<mat-sidenav-container autosize>
  <mat-sidenav
    #sidenav
    fixedInViewport="true"
    mode="side"
    [opened]="true"
  >
    <app-sidebar
      (toggleMenu)="toggleMenu()"
      [isExpanded]="isExpanded"
    ></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
